/** Why an ask didn't go ahead, in the shape the mobile apps present natively. */
export type AskFailure = {
	ok: false;
	/** Unset when no HTTP response was received. */
	status?: number;
	reason?: string;
	message?: string;
	/** From a 429's `Retry-After`, when the server gave one. */
	retryAfterSeconds?: number;
};

/**
 * The failure a generated-client call ended in, from the error body it parsed
 * and the response, which is undefined when the request never completed.
 */
export function askFailure(
	error: unknown,
	response: Response | undefined,
): AskFailure {
	const body =
		typeof error === "object" && error !== null
			? (error as Record<string, unknown>)
			: {};
	const status = response?.status;
	const retryAfter = Number(response?.headers?.get("Retry-After"));
	return {
		ok: false,
		status,
		reason: typeof body.reason === "string" ? body.reason : undefined,
		message: typeof body.message === "string" ? body.message : undefined,
		retryAfterSeconds:
			status === 429 && Number.isFinite(retryAfter) && retryAfter > 0
				? retryAfter
				: undefined,
	};
}
